import { FC } from "react";
import { QuarterlyAggregates } from "@/models/event-page";
import { formatPct } from "./helpers";
import styles from "./EventPageRevamp.module.scss";

interface HitRatesProps {
    aggregates: QuarterlyAggregates | null | undefined;
    /** Directional average next-trading-day move (signed %), to match the stats table. */
    avgNextDay?: number | null;
}

/**
 * Directional reliability rings (pre-event / next-day / week-after / month-after
 * up rate) plus the average next-day move (directional) and biggest single up /
 * down moves.
 */
const HitRates: FC<HitRatesProps> = ({ aggregates, avgNextDay }) => {
    // The aggregates object may be null, {}, or partial — read every key
    // defensively and render each tile with its own "—" fallback.
    const pr = aggregates?.positiveRate;
    const rings: [string, number | null][] = [
        ["Pre-event up rate", pr?.weekBefore ?? null],
        ["Next-day up rate", pr?.nextDay ?? null],
        ["Week-after up rate", pr?.weekAfter ?? null],
        ["Month-after up rate", pr?.monthAfter ?? null],
    ];

    const biggestUp = aggregates?.biggestUp;
    const biggestDown = aggregates?.biggestDown;

    return (
        <div className={styles.hitRates}>
            {rings.map(([label, value]) => (
                <div className={styles.hitRate} key={label}>
                    <div className={styles.hitRing} style={{ ["--p" as string]: value ?? 0 }}>
                        <span>{value == null ? "—" : `${Math.round(value)}%`}</span>
                    </div>
                    <div className={styles.hitLabel}>{label}</div>
                </div>
            ))}
            <div className={styles.hitExtra}>
                <div>
                    <span className={styles.sub}>Avg next-day move</span>
                    <span className={`${styles.num} ${avgNextDay != null ? (avgNextDay >= 0 ? styles.up : styles.down) : ""}`}>{avgNextDay == null ? "—" : formatPct(avgNextDay)}</span>
                </div>
                <div>
                    <span className={styles.sub}>Biggest pop</span>
                    <span className={`${styles.num} ${styles.up}`}>{biggestUp?.val == null ? "—" : `${formatPct(biggestUp.val)} `}<span className={styles.sub}>{biggestUp?.date ?? ""}</span></span>
                </div>
                <div>
                    <span className={styles.sub}>Biggest drop</span>
                    <span className={`${styles.num} ${styles.down}`}>{biggestDown?.val == null ? "—" : `${formatPct(biggestDown.val)} `}<span className={styles.sub}>{biggestDown?.date ?? ""}</span></span>
                </div>
            </div>
        </div>
    );
};

export default HitRates;
